
import React from 'react';
import VerifyCode from '@/components/VerifyCode';

const Verify = () => {
  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-background">
      <VerifyCode />
    </div>
  );
};

export default Verify;
